module.exports = __webpack_public_path__ + "static/media/so.9a44de75.svg";